<template>
    <div class="calendar-view p-20">
        <h2 class="text-left m-0">{{ name }}</h2>
        <div :class="`${name}-caldendar overflow-scroll`"></div>
    </div>
</template>

<script setup>
    import { onMounted, ref, defineEmits } from 'vue';

    const emit = defineEmits(['day-clicked'])

    const props = defineProps({
        data: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true
        }
    })

let mapDate = ['Sun','Mon','Tue','Wed','Thu','Fri', 'Sat']
let monthDates = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];


onMounted(() => {
  processData({
    title_present: 'Revenue',
    title_not_present: 'No revenue'
  }, props.data)
})

function getName(num) {
  return mapDate[(num - 1 + 7) % 7]
}

function processData(){
    let activityDep = document.querySelector(`.${props.name}-caldendar`);
    activityDep.classList.add('activity-chart-2d');

    const end_date = new Date()
    const endDateStr = end_date.toISOString().slice(0,10)
    let currentDateRegister = new Date('2022-01-01 00:00:00')
    let currentDate = new Date(currentDateRegister.getFullYear(), currentDateRegister.getMonth(), 1);
    let current_week_date = currentDate.getDay()
    currentDate.setDate(currentDate.getDate() - (current_week_date === 0 ? 6 : current_week_date - 1)) // Adjust to start from Monday

    let week1 = document.createElement('div')
    week1.classList.add('week')
    
    let day_div = document.createElement('div')
    day_div.classList.add('day')
    day_div.classList.add('week-name')
    
    day_div = day_div.cloneNode()
    day_div.innerHTML = 'Sun'
    week1.append(day_div)

    day_div = day_div.cloneNode()
    day_div.innerHTML = 'Mon'
    week1.append(day_div)
    
    day_div = day_div.cloneNode()
    day_div.innerHTML = 'Tue'
    week1.append(day_div)

    day_div = day_div.cloneNode()
    day_div.innerHTML = 'Wed'
    week1.append(day_div)

    day_div = day_div.cloneNode()
    day_div.innerHTML = 'Thu'
    week1.append(day_div)

    day_div = day_div.cloneNode()
    day_div.innerHTML = 'Fri'
    week1.append(day_div)

    day_div = day_div.cloneNode()
    day_div.innerHTML = 'Sat'
    week1.append(day_div)

    week1.style.width = '32px';


    activityDep.append(week1)

    let week = null
    let current_month = null
    let current_year = null
    let i = 0
    while (true) {
        if (currentDate.getDay() == 1){ // Check for Monday
            if (week) {
                activityDep.append(week)
            }
            week = document.createElement('div')
            week.classList.add('week')

            let week_month = monthDates[currentDate.getMonth()];
            if (week_month != current_month) {
                var assing_id = `${props.name}_${currentDate.getFullYear()}_${currentDate.getMonth()}`
                current_month = week_month
                let month = document.createElement('div')
                month.setAttribute('id', assing_id)
                month.style.position = 'absolute'
                month.style.top = '-20px'
                month.innerHTML = current_month
                week.append(month)

                // Check if it's January and add the year
                if (current_month === "Jan") {
                    let year = document.createElement('div')
                    year.style.position = 'absolute'
                    year.style.top = '-40px'
                    year.innerHTML = currentDate.getFullYear()
                    week.append(year)
                }
            }
        }
        let dateVariable = currentDate.toISOString().slice(0,10)
        let day = document.createElement('div')
        day.classList.add('day')
        let val = props.data[dateVariable]
        day.setAttribute('data-value', dateVariable)
        day.ondblclick = () => {
            emit('day-clicked', day.getAttribute('data-value'))
        }
        if (val) {
            var assing_id = `${props.name}_${currentDate.getFullYear()}_${currentDate.getMonth()}`
            day.style.background = `rgba(2, 146, 2, 1)`;
           
            day.setAttribute('title', `
${val.toFixed(4)} on ${getName(currentDate.getDay())}, ${dateVariable}
        `)
        } else {
            day.style.background = `rgb(250, 250, 250)`;
            day.setAttribute('title', `
${getName(currentDate.getDay())}, ${dateVariable}
            `)
        }
        week.append(day)
        if (dateVariable == endDateStr) {
            if (week) {
                if (currentDate.getDay() > 0 && currentDate.getDay() < 7 ) {
                    let week_month = monthDates[currentDate.getMonth()];
                    var assing_id = `${props.name}_${currentDate.getFullYear()}_${currentDate.getMonth()}`
                    let month = document.createElement('div')
                    month.setAttribute('id', assing_id)
                    month.style.position = 'absolute'
                    month.style.top =' -20px'
                    month.innerHTML = week_month 
                    week.append(month)
                }
                activityDep.append(week)
            }
            week = document.createElement('div')
            week.classList.add('week')
            break;
        }
        if (i > 4000) {
            break;
        }
        currentDate.setDate(currentDate.getDate() + 1)
        i+= 1
    }
}

</script>


<style lang="scss">
    .activity-chart-2d {
        padding: 20px;
        display: flex;
        height: 145px;
        width: fit-content;
        padding-top: 40px;
    }
    .week {
        height: 128px;
        display: flex;
        flex-direction: column;
        width: 17px;
        position: relative;
    }
    .day {
        width: 12px;
        height: 12px;
        margin: 0.5px;
        line-height: 1;
        font-size: 12px;
    }
    .week-name {
        width: 24px;
    }
    .overflow-scroll {
        overflow-x: scroll;
        max-width: 97%;
    }
</style>